import React, { useEffect, useState } from 'react';
import '../styles/toast.css';

const Toast = ({ message, type = 'success', duration = 2500, onClose }) => {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setExiting(true), duration);
    const t2 = setTimeout(onClose, duration + 400);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [duration, onClose]);

  const icons = {
    success: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    ),
    error: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
        <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    ),
  };

  return (
    <div className={`toast toast-${type} ${exiting ? 'toast-exit' : ''}`}>
      <span className={`toast-icon toast-icon-${type}`}>{icons[type] || icons.success}</span>
      <span className="toast-msg">{message}</span>
    </div>
  );
};

export default Toast;
